import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FcpButtonModule } from 'fc-ui-components';

import { ModalModule } from '../modal.module';
import { AccessNoteComponent } from './access-note.component';

@NgModule({
    imports: [CommonModule, TranslateModule, ModalModule, FcpButtonModule],
    declarations: [AccessNoteComponent],
    exports: [AccessNoteComponent]
})
export class AccessNoteModule {}
